import { useParams } from "react-router-dom";

export function useCourseId(): string | undefined {
  const { courseId } = useParams<{ courseId: string }>();
  return courseId;
}
